import * as ko from 'knockout'
import { SameRaceMultiViewModel } from './SameRaceMultiViewModel'
import template from './sameracemulti.tpl.html'

if (!ko.components.isRegistered('same-race-multi-bettype')) {
  ko.components.register('same-race-multi-bettype', {
    viewModel: SameRaceMultiViewModel,
    template,
  })
}
